import React, { Component } from "react";
import { Button } from "@transfr-inc/dashboard-components/forms";
import {
  Notification,
  NotificationType,
} from "@transfr-inc/dashboard-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

class TabErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: undefined,
      errorInfo: undefined,
    };
  }

  static getDerivedStateFromError(error) {
    if (
      error &&
      (error.name === "ChunkLoadError" ||
        error.message?.includes("Loading chunk") ||
        error.message?.includes("Loading CSS chunk") ||
        error.message?.includes("Failed to fetch") ||
        error.message?.includes("Network request failed"))
    ) {
      return;
    }

    return {
      hasError: true,
      error,
    };
  }

  componentDidCatch(error, errorInfo) {
    console.error(
      "Tab Error Boundary caught a rendering error:",
      error,
      errorInfo
    );

    this.setState({
      error,
      errorInfo,
    });
  }

  handleRetry() {
    this.setState({
      hasError: false,
      error: undefined,
      errorInfo: undefined,
    });

    if (this.props.onRetry) {
      this.props.onRetry();
    }
  }

  render() {
    const { hasError, error, errorInfo } = this.state;
    const { children, tabName, onRefresh } = this.props;

    if (hasError) {
      return (
        <div className="tab-error-boundary">
          <Notification
            type={NotificationType.error}
            icon={["fa-solid", "exclamation-triangle"]}
            closable={false}
          >
            <div className="error-content">
              <h4>Failed to load {tabName || "tab"}</h4>
              <p>
                There was an error loading this section. This might be due to a
                network issue or server problem.
              </p>
              <div className="error-actions">
                <Button onClick={this.handleRetry} primary>
                  <FontAwesomeIcon icon={["fa-solid", "refresh"]} /> Try Again
                </Button>
                {onRefresh && (
                  <Button onClick={onRefresh}>
                    <FontAwesomeIcon icon={["fa-solid", "sync"]} /> Refresh Page
                  </Button>
                )}
              </div>
              {process.env.NODE_ENV === "development" && error && (
                <details className="error-details">
                  <summary>Error Details (Development)</summary>
                  <pre>{error.toString()}</pre>
                  {errorInfo && <pre>{errorInfo.componentStack}</pre>}
                </details>
              )}
            </div>
          </Notification>
        </div>
      );
    }

    try {
      return children;
    } catch (renderError) {
      console.error("Error in tab content rendering:", renderError);
      return (
        <div className="tab-error-fallback">
          <p>
            Content temporarily unavailable. Please try refreshing the page.
          </p>
        </div>
      );
    }
  }
}

export default TabErrorBoundary;
